// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageViewer {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}

.viewportWrapper {
  position: relative;
  border: 1px solid #333;
  box-sizing: border-box;
}

.viewport {
  width: 100%;
  height: 100%;
  background-color: #000;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  color: white;
  padding: 5px;
}

.overlay-element {
  position: absolute;
  font-size: 12px;
  text-shadow: 1px 1px 2px black;
}

.top-left {
  top: 5px;
  left: 5px;
}

.top-right {
  top: 5px;
  right: 5px;
}

.bottom-left {
  bottom: 5px;
  left: 5px;
}

.bottom-right {
  bottom: 5px;
  right: 5px;
}

.thumbnailSelector {
  flex-shrink: 0;
  width: 150px;
  height: 100%;
  overflow-y: auto;
  padding: 8px;
  border-right: 1px solid #333;
}

.viewportsContainer {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  position: relative;
}

.thumbnail {
  cursor: pointer;
  margin-bottom: 8px;
  padding: 4px;
  background: #333;
  color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumbnail:hover {
  background: #555;
}

.thumbnail.selected {
  border: 2px solid #004c86;
  padding: 2px;
}

.thumbnail-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
  background: #000;
  border-radius: 2px;
  margin-bottom: 5px;
}

.thumbnail-info {
  width: 100%;
  text-align: center;
}

.thumbnail-info div:first-child {
  font-size: 11px;
  font-weight: 500;
}

.thumbnail-info div:last-child {
  font-size: 9px;
  color: #aaa;
}`, "",{"version":3,"sources":["webpack://./src/components/ImageViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb","sourcesContent":[".imageViewer {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  width: 100%;\n}\n\n.viewportWrapper {\n  position: relative;\n  border: 1px solid #333;\n  box-sizing: border-box;\n}\n\n.viewport {\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  color: white;\n  padding: 5px;\n}\n\n.overlay-element {\n  position: absolute;\n  font-size: 12px;\n  text-shadow: 1px 1px 2px black;\n}\n\n.top-left {\n  top: 5px;\n  left: 5px;\n}\n\n.top-right {\n  top: 5px;\n  right: 5px;\n}\n\n.bottom-left {\n  bottom: 5px;\n  left: 5px;\n}\n\n.bottom-right {\n  bottom: 5px;\n  right: 5px;\n}\n\n.thumbnailSelector {\n  flex-shrink: 0;\n  width: 150px;\n  height: 100%;\n  overflow-y: auto;\n  padding: 8px;\n  border-right: 1px solid #333;\n}\n\n.viewportsContainer {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  height: 100%;\n  position: relative;\n}\n\n.thumbnail {\n  cursor: pointer;\n  margin-bottom: 8px;\n  padding: 4px;\n  background: #333;\n  color: white;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.thumbnail:hover {\n  background: #555;\n}\n\n.thumbnail.selected {\n  border: 2px solid #004c86;\n  padding: 2px;\n}\n\n.thumbnail-image {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n  background: #000;\n  border-radius: 2px;\n  margin-bottom: 5px;\n}\n\n.thumbnail-info {\n  width: 100%;\n  text-align: center;\n}\n\n.thumbnail-info div:first-child {\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.thumbnail-info div:last-child {\n  font-size: 9px;\n  color: #aaa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
